export default {
    add: {
        ar: 'إضافة',
        en: 'add',
        es: 'agregar',
    },
    all: {
        ar: 'الكل',
        en: 'all',
        es: 'Todos'
    },
    edit: {
        ar: 'تعديل',
        en: 'edit',
        es: 'editar',
    },
    delete: {
        ar: 'حذف',
        en: 'delete',
        es: 'borrar',
    },
    save: {
        ar: 'حفظ',
        en: 'save',
        es: 'ahorrar',
    },
    cancel: {
        ar: 'إلغاء',
        en: 'cancel',
        es: 'cancelar',
    },
    search: {
        ar: 'بحث',
        en: 'Search',
        es: 'Buscar',
    },
    update: {
        ar: 'تحديث',
        en: 'Update',
        es: 'actualizar'
    },
    close: {
        ar: 'إغلاق',
        en: 'close',
        es: 'close'
    },
    'save-for-warehouse': {
        ar: 'حفظ مستودعياً',
        en: 'save for warehouse',
        es: 'guardar en almacén',
    },
    'save-for-accounting': {
        ar: 'حفظ محاسبياً',
        en: 'save for accounting',
        es: 'guardar en contabilidad',
    },
    'edit-for-warehouse': {
        ar: 'تعديل مستودعياً',
        en: 'edit for warehouse',
        es: 'editar en almacén',
    },
    'edit-for-accounting': {
        ar: 'تعديل محاسبياً',
        en: 'edit for accounting',
        es: 'editar en contabilidad',
    },    
    'save-for-all': {
        ar: 'حفظ كلي',
        en: 'save for all',
        es: 'guardar para todos',
    },
    'edit-for-all': {
        ar: 'تعديل كلي',
        en: 'edit for all',
        es: 'editar para todos',
    },
    change: {
        ar: 'تغيير',
        en: 'change',
        es: 'cambiar'
    },
    'total-invoices-statement': {
        ar: 'كشف الفواتير',
        en: 'Invoices Statement',
        es: 'Estado de Factura'
    },

    'purchases-statement': {
        ar: 'كشف مشتريات',
        en: 'Purchases Statement',
        es: 'Estado de Compras'
    },

    'sales-statement': {
        ar: 'كشف مبيعات',
        en: 'Sales Statement',
        es: 'declaración de ventas'
    },

    exports: {
        ar: {
            export: 'تصدير',
            'export-as-pdf': 'تصدير كـ pdf',
            'export-as-excel': 'تصدير كـ Excel',
        },
        en: {
            export: 'Export',
            'export-as-pdf': 'Export as pdf',
            'export-as-excel': 'Export as excel',
        },
        es: {
            export: 'Exportar',
            'export-as-pdf': 'Export as pdf',
            'export-as-excel': 'Export as excel',
        },
    },
    bonds: {
        ar: {
            'delete-bond': 'حذف سند',
            'delete-bond-confirm':'هل أنت متأكد من حذف السند؟'
        },
        en: {
            'delete-bond': 'delete-bond',
            'delete-bond-confirm': 'Are you sure you want to delete the bond?'
        },
        es: {
            'delete-bond':'Eliminar bono',
            'delete-bond-confirm': '¿Estás seguro de que quieres eliminar el bono?'
        }
    },
    inputs: {
        ar: {
            name: 'الاسم',
            'fiscal-year': 'السنة المالية',
            'show-archived': 'عرض المؤرشفة',
            'company-name': 'اسم الشركة',
            'financial-file-start': 'تاريخ بداية الملف المالي',
            'financial-file-end': 'تاريخ نهاية الملف المالي',
            'currency': 'العملة',
            'default-language': 'اللغة الافتراضية',
            permission: 'الصلاحية',
            'refunded-from-invoice': 'مرتجع من فاتورة',
            date: 'التاريخ',
            'ref-doc': 'المستند',
            notes: 'ملاحظات',
            account: 'الحساب',
            warehouse: 'المستودع',
            warehouses: 'المستودعات',
            'undefined': 'غير مُحدد',
            'sales-account': 'حساب المبيعات',
            'purchasing-account': 'حساب المشتريات',
            'sales-refund-account': 'حساب مرتجع المبيعات',        
            'purchasing-refund-account': 'حساب مرتجع المشتريات',
            type: 'النوع',
            material: 'المادة',
            'from-date': 'من تاريخ',
            'to-date': 'إلى تاريخ',
            'barcode': 'باركود',
            'region-name': 'اسم المنطقة',
            class: 'الصف',
            column: 'العمود',
            'invoice-category-name': 'اسم النمط',
            'invoice-category': 'نمط الفاتورة',
            'invoice-status': 'حالة الفاتورة',
            'invoice-no': 'رقم الفاتورة',
            'bond-date': "تاريخ السند",
            "status": "الحالة"
        },
        en: {
            name: 'Name',
            'fiscal-year': 'Fiscal year',
            'show-archived': 'Show archived',
            'company-name': 'Company name',
            'financial-file-start': 'Financial file start date',
            'financial-file-end': 'Financial file end date',
            'currency': 'Default language',
            'default-language': 'Name',
            permission: 'Permission',
            'refunded-from-invoice': 'Refunded from invoice',
            date: 'Date',
            'ref-doc': 'Ref. Doc.',
            notes: 'notes',
            account: 'Account',
            warehouse: 'Warehouse',
            warehouses: 'Warehouses',
            'undefined': 'Undefined',
            'sales-account': 'Sales account',
            'purchasing-account': 'Purchasing account',
            'sales-refund-account': 'Sales refund account',
            'purchasing-refund-account': 'Purchasing refund account',
            type: 'Type',
            material: 'Item',
            'from-date': 'From date',
            'to-date': 'To date',
            'barcode': 'Barcode',
            'region-name': 'Region name',
            class: 'Class',
            column: 'Column',
            'invoice-category-name': 'Category name',
            'invoice-category': 'Invoice category',
            'invoice-status': 'Invoice status',
            'invoice-no': 'Invoice number',
            'bond-date': "Bond date",
            "status": "Status"
        },
        es: {
            name: 'Nombre',
            'fiscal-year': 'Año fisical',
            'show-archived': 'Mostrar archivado',
            'company-name': 'Nombre de empresa',
            'financial-file-start': 'Fecha de inicio de archivo financiero',
            'financial-file-end': 'Fecha de finalización de archivo financiero',
            'currency': 'Idioma por defecto',
            'default-language': 'Moneda',
            permission: 'Permiso',
            'refunded-from-invoice': 'Devuelto de factura',
            date: 'Fecha',
            'ref-doc': 'Ref. Doc.',
            notes: 'Notas',
            account: 'Cuenta',
            warehouse: 'Almacén',
            warehouses: 'Almacenes',
            'undefined': 'Indefinido',
            'sales-account': 'Sales account',
            'purchasing-account': 'Purchasing account',
            'sales-refund-account': 'Sales refund account',
            'purchasing-refund-account': 'Purchasing refund account',
            type: 'Tipo',
            material: 'Artículo',
            'from-date': 'De fecha',
            'to-date': 'Hasta fecha',
            'barcode': 'Código de barras',
            'region-name': '',
            class: '',
            column: '',
            'invoice-category-name': 'Categoría Nombre',
            'invoice-category': 'Categoría de factura',
            'invoice-status': 'Estado de la factura',
            'bond-date': 'Fecha del bono',
            'invoice-no': 'Número de factura',
            'status': 'Estado'
        },
    },

    buttons: {
        ar: {
            'change-state': 'تغيير الحالة',
            add: 'إضافة',
            create: 'إنشاء',
            new: 'جديد',
            'add-child': 'إضافة حساب فرعي',
            "add-child-material": "إضافة مادة فرعية",
            'account-statement': 'كشف حساب',
            'material-statement': "كشف مادة",
            edit: 'تعديل',
            delete: 'حذف',
            show: 'عرض',
            save: 'حفظ', 
            cancel: 'إلغاء', 
            browse: 'استعراض',
            previous: 'السابق',
            next: 'التالي',
            manage: 'إدارة',
            ok: 'موافق',
            search: 'بحث',
            back: 'رجوع',
            pin: 'تثبيت',
            customize: "تخصيص",
            skip: "تخطي",
            start: 'البدء',
            close: 'إغلاق'
        },

        en: {
            'change-state': 'Change status',
            add: 'Add',
            create: 'Create',
            new: 'New',
            'add-child': 'Add sub account',
            "add-child-material": "Add sub material",
            'account-statement': 'Account statement',
            'material-statement': "Material statement",
            edit: 'Edit',
            delete: 'Delete',
            show: 'Show',
            save: 'Save', 
            cancel: 'Cancel', 
            browse: 'Browse',
            previous: 'Previous',
            next: 'Next',
            manage: 'Manage',
            pin: 'pin',
            ok: 'OK',
            search: 'Search',
            back: 'Back',
            skip: 'Skip',
            start: "Start",
            close: 'Close'
        },

        es: {
            'change-state': 'Cambiar estado',
            add: 'Añadir',
            create: 'Crear',
            new: 'Nuevo',
            'add-child': 'Agregar subcuenta',
            "add-child-material": "Agregar submaterial",
            'account-statement': 'Estado de cuenta',
            'material-statement': "Estado de material",
            edit: 'Editar',
            delete: 'Eliminar',
            show: 'Mostrar',
            save: 'Guardar',
            cancel: 'Cancelar',
            browse: 'Navegar',
            previous: 'Anterior',
            next: 'Próximo',
            "pin": "Fijar",
            manage: 'Gestionar',
            ok: 'De acuerdo',
            search: 'Buscar',
            back: 'atrás',
            skip: 'Saltar',
            start: "Comenzar",
            close: 'Cerrar'
        },
    },

    headers: {
        ar: {
            'company-name': 'اسم الشركة',
            'fiscal-year': 'السنة المالية',
            'start-date-of-the-file': 'تاريخ بداية الملف',
            'end-date-of-the-file': 'تاريخ نهاية الملف',
            currency: 'العملة',
            state: 'الحالة',
            actions: 'الأحداث',
            no: 'الرقم',
            warehouse: 'المستودع',
            material: 'المادة',
            quantity: 'الكمية',
            count: 'العدد',
            price: 'السعر',
            notes: 'ملاحظات',
            'net-amount': 'صافي القيمة',
            type: 'النوع',
            total: 'الإجمالي',
            account: 'الحساب',
            'ref-doc': 'المستند',
            date: 'التاريخ',
            "source-warehouse": 'المستودع المصدر',
            "target-warehouse": 'المستودع الهدف',
            'paper-document-no': 'المستند الورقي',
            'amount': 'القيمة',
            'region-name': 'اسم المنطقة',
            class: 'الصف',
            column: 'العمود',
            balance: 'الرصيد',
            debit: 'مدين',
            credit: 'دائن',
            note: 'البيان',
            'trade-accounts': 'حسابات المتاجرة',
            'invoice-category-name': 'اسم النمط',
            'delivery-status': 'حالة تسليم المادة',
            'manufacturer-code': 'كود التصنيع',
            'invoice-number': 'ر.الفاتورة',
            'invoice-type': 'نوع الفاتورة',
            'status': 'الحالة',
            'category': 'الصنف',
            'material-specifications': 'مواصفات المادة',
            'serial-number': 'الرقم التسلسلي',
            'backup-name': 'اسم النسخة',
            'backup-date': 'تاريخ الإنشاء'
        },
        en: {
            'company-name': 'Company name',
            'fiscal-year': 'Fiscal year',
            'start-date-of-the-file': 'Financial file start date',
            'end-date-of-the-file': 'Financial file end date',
            currency: 'Currency',
            state: 'Status',
            actions: 'Actions',
            no: 'Serial',
            warehouse: 'Warehouse',
            material: 'Item',
            quantity: 'Quantity',
            count: 'Count',
            price: 'Price',
            notes: 'notes',
            'net-amount': 'Net amount',
            type: 'Type',
            total: 'Total',
            account: 'Account',
            'ref-doc': 'Ref. Doc.',
            date: 'Date',
            "source-warehouse": "Source warehouse",
            "target-warehouse": "Target warehouse",
            'paper-document-no': 'Paper document no',
            'amount': 'Amount',
            'region-name': 'Region name',
            class: 'Class',
            column: 'Column',
            balance: 'Balance',
            debit: 'Debit',
            credit: 'Credit',
            note: 'Note',
            'trade-accounts': 'Trade accounts',
            'invoice-category-name': 'Category name',
            'delivery-status': 'Delivery status',
            'manufacturer-code': 'Manufacturer code',
            'invoice-number': 'Invoice number',
            'invoice-type': 'Invoice type',
            'status': 'Status',
            category: 'Category',
            'material-specifications': 'Material specifications',
            'serial-number': 'Serial Number',
            'backup-name': 'Backup Name',
            'backup-date': 'Creation Date'
        },
        es: {
            'company-name': 'Nombre de empresa',
            'fiscal-year': 'Año fisical',
            'start-date-of-the-file': 'Fecha de inicio de archivo financiero',
            'end-date-of-the-file': 'Fecha de finalización de archivo financiero',
            currency: 'Moneda',
            state: 'Estado',
            actions: 'Acciones',
            no: 'Número',
            warehouse: 'Almacén',
            material: 'Artículo',
            quantity: 'Cantidad',
            count: 'Conteo',
            price: 'Precio',
            notes: 'Notas',
            'net-amount': 'Valor neto',
            type: 'Tipo',
            total: 'Total',
            account: 'Cuenta',
            'ref-doc': 'Ref. Doc.',
            date: 'Fetch',
            "source-warehouse": 'Almacén de origen',
            "target-warehouse": 'Almacén objetivo',
            "paper-document-no": "",
            "amount": "",
            'region-name': "",
            class: '',
            column: '',
            balance: 'Balance',
            debit: 'Débito',
            credit: 'crédito',
            note: 'nota',
            'trade-accounts': 'Cuentas comerciales',
            'invoice-category-name': 'Categoría Nombre',
            'delivery-status': 'Estado de entrega',
            'manufacturer-code': 'Código del fabricante',
            'invoice-number': 'Número de factura',
            'invoice-type': 'Tipo de factura',
            'status': 'Estado',
            category: 'Categoría',
            'material-specifications': 'Detalles de la Material',
            'serial-number': 'Número de serie',
            'backup-name': 'Nombre de respaldo',
            'backup-date': 'Fecha de creación'
        },
    },

    tooltip: {
        ar: {
            cached: 'تحديث سعر العملة',
            history: 'عرض سجل تحديث العملة',
            statement: 'كشف',
            folder: 'عرض ملفات المُستخدم',
            'preview-file': 'استعراض محتويات الملف',
            inventory: 'جرد مواد المستودع' ,
            upload: 'إرفاق لوغو',
            archive: 'أرشفة',
            unarchive: 'إلغاء الأرشفة',
            'change-state': 'تغيير الحالة',
            edit: 'تعديل',
            delete: 'حذف',
        },
        en: {
            cached: 'Update exchange rate',
            history: 'Exchange rate history',
            statement: 'Statement',
            folder: 'Show user files',
            'preview-file': 'Preview file',
            inventory: 'Warehouse items inventory',
            upload: 'Attach logo',
            archive: 'Archive',
            unarchive: 'Unarchive',
            'change-state': 'Change status',
            edit: 'Edit',
            delete: 'Delete',
        },
        es: {
            cached: 'Actualizar tipo de cambio',
            history: 'Mostrar historial de tipos de cambio',
            statement: 'Estado',
            folder: 'Mostrar archivos de usuario',
            'preview-file': 'Vista previa del archivo',
            inventory: 'Inventario de artículos de almacén',
            upload: 'Adjuntar logo',
            archive: 'Archivo',
            unarchive: 'Desarchivar',
            'change-state': 'Cambiar estado',
            edit: 'Editar',
            delete: 'Eliminar',
        }
    },

    components: {
        ar: {
            'shown-rows': 'الأسطر المعروضة'
        },
        en: {
            'shown-rows': 'Shown rows'
        },
        es: {
            'shown-rows': 'Filas mostradas'
        },
    },

    invoices: {
        ar: {
            'available-next-version': 'سيتم إتاحة الميزة في إصدار لاحق',
            'add-invoice': 'إضافة فاتورة',
            'delete-invoice': 'حذف فاتورة',
            'delete-invoice-confirm': 'هل أنت متأكد من حذف الفاتورة سيتم حذف السند المُرتبط أيضاً؟',
            'invoice-no': 'رقم الفاتورة',
            'net-invoice': 'صافي الفاتورة',
            posted: 'مُرحّلة',
            'non-posted': 'غير مُرحّلة',
            'fully-posted': 'مرحلة كليا',
            'warehouse-non-posted': ' غير مرحلة مستودعيا',
            'non-posted-for-accounting': 'غير مرحلة محاسبيا',
            'warehouse-posted': 'مرحلة مستودعياً فقط',
            'posted-for-accounting': 'مرحلة محاسبياً فقط',
            total: 'الإجمالي',
            'delete-entry': 'حذف قيد',
            'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف القيد؟',
        },
        en: {
            'available-next-version': 'The feature will be available in a later version',
            'add-invoice': 'Add invoice',
            'delete-invoice': 'Delete invoice',
            'delete-invoice-confirm': 'Do you want to  delete this invoice? the related bond will also be deleted?',
            'invoice-no': 'Invoice no',
            'net-invoice': 'Grand Amount',
            posted: 'Posted',
            'non-posted': 'Non posted',
            "fully-posted": "Fully posted",
            "warehouse-non-posted": "Not posted for warehouse",
            "non-posted-for-accounting": "Not posted for accounting",
            'warehouse-posted': 'posted for warehouse',
            'posted-for-accounting': 'posted for accounting',
            total: 'Total',
            'delete-entry': 'Delete entry',
            'are-you-sure-you-want-to-delete-the-entry': 'Are you sure you want to delete the entry?',
        },
        es: {
            'available-next-version': 'La característica estará disponible en una versión posterior',
            'delete-invoice': 'Eliminar factura',
            'add-invoice': 'Añadir factura',
            'delete-invoice-confirm': '¿Está seguro de eliminar la factura, el bono asociado también se eliminará?',
            'invoice-no': 'Número de factura',
            'net-invoice': 'Gran cantidad',
            posted: 'Publicado',
            'non-posted': 'No-publicado',
            "fully-posted": "Registrado completamente",
            "warehouse-non-posted": "No registrado en almacén",
            "non-posted-for-accounting": "No registrado en contabilidad",
            total: 'total',
            'warehouse-posted': 'registrado en almacén',
            'posted-for-accounting' : 'registrado en contabilidad',
            'delete-entry': 'Eliminar la entrada',
            'are-you-sure-you-want-to-delete-the-entry': '¿Está seguro de que desea eliminar la entrada?',
        }
    },

    'table-messages': {
        ar: {
            'debit-and-credit-required': 'يجب إدخال إحدى حقول المدين / الدائن',
            'cash-debit-and-credit-required': "يجب إدخال إحدى حقول الصادر / الوارد",
            'debit-and-credit-one-of': 'لا يمكن إدخال مدين ودائن ضمن قيد واحد',
            'cash-debit-and-credit-one-of': 'لا يمكن إدخال صادر و وارد ضمن قيد واحد',
            'account-required': 'يجب إدخال اسم الحساب',
            'date-required': 'يجب إدخال تاريخ القيد',
            'no-currency-debit-and-credit-without-currency': 'لا يجب إدخال حقول عملة مدينة / عملة دائنة بدون تحديد العملة',
            'currency-debit-and-credit-required': 'يجب إدخال إحدى حقول عملة مدينة / عملة دائنة',
            'currency-debit-and-credit-one-of': 'لا يمكن إدخال عملة دائنة وعملة مدينة ضمن قيد واحد',
            'debit-with-currency-debit-relation': 'يشترط توافق ملء كلا من مدين مع عملة مدينة',
            'credit-with-currency-credit-relation': 'يشترط توافق ملء كلا من دائن مع عملة دائنة',
            'currency-required': 'يجب اختيار نوع العملة ثم ضبط السعر',
            'currency-price-required': 'يجب إدخال سعر العملة',

            'material-required': 'يجب إدخال حقل المادة',
            'quantity-required': 'يجب إدخال حقل الكمية',
            'price-required': 'يجب إدخال حقل السعر',
            'quantity-on-or-out-required':'يجب إدخال إحدى حقول الكمية الداخلة أو الخارجة',
            'quantity-on-and-out-forbidden':'لا يمكن إدخال كمية داخلة وخارجة ضمن قيد واحد',
        },  
        en: {
            'debit-and-credit-required': 'One of the debit / credit fields must be entered',
            'debit-and-credit-one-of': 'Debit and credit can\'t be entered in one entry',
            'cash-debit-and-credit-required': 'One of the debit / credit fields must be entered',
            'cash-debit-and-credit-one-of': 'Debit and credit can\'t be entered in one entry',
            'account-required': 'Account must be entered',
            'date-required': 'Entry date must be entered',
            'no-currency-debit-and-credit-without-currency': 'Currency must be entered before the foreign currency credit / debit',
            'currency-debit-and-credit-required': 'One of the foreign currency credit / debit must be entered',
            'currency-debit-and-credit-one-of': 'Foreign currency debit and foreign currency credit can\'t be entered in the same entry',
            'debit-with-currency-debit-relation': 'Specify Foreign currency debit for debit (incompatible inputs)',
            'credit-with-currency-credit-relation': 'Specify foreign currency credit for credit (incompatible inputs)',
            'currency-required': 'Choose currency before',
            'currency-price-required': 'Currency price must be entered',
            
            'quantity-required': 'Quantity is required',
            'price-required': 'Price is required',
            'material-required': 'Item is required ',
            'quantity-on-or-out-required':'Quantity is required',
            'quantity-on-and-out-forbidden':'Specify in or out quantity, you can`t enter both'
        },
        es: {
            'debit-and-credit-required': 'Se debe ingresar uno de los campos de débito/crédito',
            'debit-and-credit-one-of': 'El débito y el crédito no se pueden ingresar en un solo asiento',
            'cash-debit-and-credit-required': 'Se debe ingresar uno de los campos de débito/crédito',
            'cash-debit-and-credit-one-of': 'El débito y el crédito no se pueden ingresar en un solo asiento',
            'account-required': 'Se debe ingresar la cuenta',
            'date-required': 'Se debe ingresar la fecha de entrada.',
            'no-currency-debit-and-credit-without-currency': 'La moneda debe ingresarse antes del crédito/débito de moneda extranjera.',
            'currency-debit-and-credit-required': 'Se debe ingresar una de las monedas de débito/crédito',
            'currency-debit-and-credit-one-of': 'La moneda de débito y crédito no se puede ingresar en el mismo asiento',
            'debit-with-currency-debit-relation': 'Especifique la moneda de débito para el deudor (entradas incompatibles)',
            'credit-with-currency-credit-relation': 'Especifique la moneda de crédito para el acreedor (entradas incompatibles)',
            'currency-required': 'Elija la moneda antes de agregar el precio',
            'currency-price-required': 'Se debe ingresar el precio de la moneda',

            'quantity-required': 'Se requiere cantidad',
            'price-required': 'Se requiere precio',
            'material-required': 'Se requiere artículo',
            'quantity-on-or-out-required':'Debe ingresar uno de los campos de cantidad de entrada/salida.',
            'quantity-on-and-out-forbidden':'Especifique la cantidad de entrada o salida, no puede ingresar ambos'
        },
    },

    menus: {
        ar: {
            'show-related-invoice': 'عرض الفاتورة المرتبطة',
            'show-related-journal': 'عرض اليومية المرتبطة',
            'account-statement': 'كشف حساب'
        },
        en: {
            'show-related-invoice': 'Show related invoice',
            'show-related-journal': 'Show related journal',
            'account-statement': 'Account statement'
        },
        es: {
            'show-related-invoice': 'Mostrar factura relacionada',
            'show-related-journal': 'Mostrar diario relacionado',
            'account-statement': 'Estado de cuenta'
        }
    },
    
    messages: {
        ar: {
            'available-next-version': 'سيتم إتاحة الميزة في إصدار لاحق',
            'revolve-succeeded': 'خطوات التدوير تمت بنجاح، أعد تسجيل الدخول رجاءً',
            'adding-completed-successfully': 'تمت عملية الإضافة بنجاح',
            'editing-completed-successfully': 'تمت عملية التعديل بنجاح'
        },
        en: {
            'available-next-version': 'The feature will be available in a later version',
            'revolve-succeeded': 'Revolve steps are succeeded. please, login again',
            'adding-completed-successfully': 'adding operation completed successfully',
            'editing-completed-successfully': 'editing operation completed successfully'
        },
        es: {
            'available-next-version': 'La característica estará disponible en una versión posterior',
            'revolve-succeeded': 'Los pasos de revolución se realizan correctamente. por favor, inicie sesión nuevamente',
            'adding-completed-successfully': 'Agregar operación completada con éxito',
            'edit-completed-successfully': 'Operación de edición completada con éxito',
        }
    },

    'shown-rows-text': {
        ar: 'الأسطر المعروضة',
        en: 'shown rows',
        es: 'filas mostradas',
    },
"posted-invoices": {
        ar: 'فواتير مرحلة',
        en: 'Posted invoices',
        es: ''
    },

    "unposted-invoices": {
        ar: 'فواتير غير مرحلة',
        en: 'Unposted invoices',
        es: ''
    },
    posted: {
        ar: 'مرحلة',
        en: 'Posted',
        es: ''
    },
    unposted: {
        ar: 'غير مرحلة',
        en: 'unposted',
        es: ''
    },
    // FIXME REMOVE NEXT TRANLSATES
    // -------------------
    "user permission": {
        ar: 'صلاحيات المستخدم',
        en: 'User Permission',
        es: 'Permiso de usuario'
    },
    "users permissions": {
        ar: 'صلاحيات المستخدمين',
        en: 'Users Permissions',
        es: 'permisos de usuarios'
    },
    'validation.required': {
        ar: 'هذا الحقل إجباري',
        en: 'This field is required',
        es: 'Este campo es obligatorio'
    },
    'financial-file': {
        ar: 'الملف المالي',
        en: 'Financial File',
        es: 'expediente financiero'
    },
    refunds: {
        ar: {
            'sale-refund-config-account': 'حساب مرتجع المبيعات',
            'buy-refund-config-account': 'حساب مرتجع المشتريات',
            'invoice-categories': 'نمط الفاتورة'
        },
        en: {
            'sale-refund-config-account': 'Sales Refund Account',
            'buy-refund-config-account': 'Purchase Refund Account',
            'invoice-categories': 'Invoice Categories'
        },
        es: {
            'sale-refund-config-account': 'Calcular retorno de ventas',
            'buy-refund-config-account': 'Cálculo de devolución de compra',
            'invoice-categories': 'categoría de factura'
        }
    },
    // -------------------
    
    'invoice-type': {
        ar: {
            'sales': 'مبيعات',
            'purchases': 'مشتريات',
            'sales-refund': 'مرتجع مبيعات',
            'purchases-refund': 'مرتجع مشتريات',
        },
        en: {
            'sales': 'Sales',
            'purchases': 'Purchases',
            'sales-refund': 'Sales refund',
            'purchases-refund': 'Purchases refund',
        },
        es: {
            'sales': 'Ventas',
            'purchase': 'Compras',
            'sales-refund': 'Reembolso de ventas',
            'purchases-refund': 'Reembolso de compras',
        },
    },
    'invoice-types': {
        ar: {
            'sales-invoice': 'مبيع',
            'purchase-invoice': 'شراء',
            'sales-refund-invoice': 'مرتجع مبيع',
            'purchases-refund-invoice': 'مرتجع شراء'
        },
        en: {
            'sales-invoice': 'Sale invoice',
            'purchase-invoice': 'Purchase invoice',
            'sales-refund-invoice': 'Sales refund',
            'purchases-refund-invoice': 'Purchases refund'
        },
        es: {
            'sales-invoice': 'factura de venta',
            'purchase-invoice': 'factura de compra',
            'sales-refund-invoice': 'Reembolso de ventas',
            'purchases-refund-invoice': 'Reembolso de compras'
        }
    },
    'account-movement-chart': {
        ar: 'مخطط حركة الحساب',
        en: 'Account state chart',
        es: 'Cuadro de estado de cuenta'
    },

    'material-edit-types': {
        ar: {
            names: 'فقط الاسم',
            data: 'البيانات بدون الاسم',
            all: 'جميع البيانات'
        },
        en: {
            names: 'Only Names',
            data: 'Data without names',
            all: 'All data'
        },
        es: {
            names: 'Sólo nombres',
            data: 'Datos sin nombres',
            all: 'Todos los datos'
        }
    },

    'dialog-content': {
        ar: {
            'confirm-dialog-title': 'تأكيد الحفظ',
            'confirm-dialog-content': 'تم إدخال بعض الحقول الناقصة في أخر قيد, لذا لن يتم حفظ اخر قيد أدخل',
            'confirm-dialog-actions': {
                confirm: 'تأكيد',
                cancel: 'إلغاء'
            }
        },
    
        en: {
            'confirm-dialog-title': 'something in the title',
            'confirm-dialog-content': 'something in the content',
            'confirm-dialog-actions': {
                confirm: 'Confirm',
                cancel: 'Cancel'
            }
        },
    
        es: {
            'confirm-dialog-title': 'something in the title',
            'confirm-dialog-content': 'something in the content',
            'confirm-dialog-actions': {
                confirm: 'confirmar',
                cancel: 'Cancelar'
            }
        }
    },

    'delivery-status': {
        ar: 'حالة التسليم',
        en: 'Delivery Status',
        es: 'estado de entrega'
    },

    'select-all': {
        ar: 'اختيار الكل',
        en: 'Select All',
        es: 'seleccionar todo'
    },

    'total-of-totals': {
        ar: 'مجموع الإجمالي',
        en: 'Total of totals',
        es: 'Total del total'
    },

    total: {
        ar: 'الكلي',
        en: 'total',
        es: 'total'
    },

    'total-quantities': {
        ar: 'مجموع الكميات',
        en: 'Total Quantities',
        es: 'tcantidades totalesotal'
    },

    'total-counts': {
        ar: 'مجموع الأعداد',
        en: 'Total Counts',
        es: 'recuentos totales'
    },

    'invoice-info': {
        ar: 'سجل الاستخدام',
        en: 'Invoice Information',
        es: 'información de factura'
    },
    
    'invoice-headers': {
        ar: {
            action: 'التغيير',
            'date-formatted': 'التاريخ و الوقت',
            'user': 'المستخدم'
        },
        en: {
            action: 'Action',
            'date-formatted': 'Date and time',
            'user': 'Name'
        },
        es: {
            action: 'acción',
            'date-formatted': 'fecha y hora',
            'user': 'usuario'
        }
    },

    'context-menu': {
        ar: {
            'go-to-invoice': 'الانتقال الى الفاتورة'
        },
        en: {
            'go-to-invoice': 'Go to invoice'
        },
        es: {
            'go-to-invoice': 'ir a la factura'
        }
    },

    'change-currency': {
        ar: {
            'change-invoice-currency': 'تغيير عملة الفاتورة',
            'select-the-currency': 'يرجى اختيار عملة الفاتورة',
            'currency': 'العملة',
            'currency-value': 'قيمة العملة',
            'set-the-value-of-the-currency': 'يرجى وضع قيمة العملة'
        }
    },

    'change-currency-alert': {
        ar: {
            'dialog-header': 'إجراء خاطئ',
            'can-not-change-currency': 'عذرًا، لا يتم دعم التحويل المباشر للعملات الأجنبية. يُرجى تحويل العملة إلى العملة الأساسية للنظام أولا، ثم إلى العملة المستهدفة.'
        },
        en: {
            'dialog-header': 'Incorrect action',
            'can-not-change-currency': "Direct foreign currency conversion is not supported. Please convert the amount to the system's base currency first,then to the target currency"
        },
        es: {
            'dialog-header': 'acción incorrecta',
            'can-not-change-currency': 'Lo sentimos, no se admite la conversión directa de moneda extranjera. Primero convierta la moneda a la moneda base del sistema y luego a la moneda de destino.'
        }
    },
    'notifications': {
        ar: {
            'change-setting-alert': 'تم تغيير الإعداد بنجاح'
        },
        en:{
            'change-setting-alert' : 'settting has changed successfully'
        },
        es: {
            'change-setting-alert': 'Configuración cambiada con éxito'
        }
    },
    'global-settings': {
        ar: 'إعدادات النظام',
        en: 'System Settings',
        es: 'Configuración del sistema'
    },
    'timezone-alert': {
        ar: 'اختلاف المنطقة الزمنية',
        en: 'Time zone mismatch',
        es: 'Diferencia de zona horaria'
    },
    'timezone-alert-description': {
        ar: 'إن المنطقة الزمنية المحددة للمستخدم مختلفة عن المنطقة الحالية للجهاز',
        en: 'The user’s selected time zone is different from the current device time zone',
        es: 'La zona horaria seleccionada por el usuario es diferente de la zona horaria actual del dispositivo'
    },
    'user-timezone': {
        ar: 'منطقة المستخدم',
        en: 'User Time Zone',
        es: 'Zona horaria del usuario'
    },
    'current-timezone': {
        ar: 'المنطقة الحالية',
        en: 'Current Time Zone',
        es: 'Zona horaria actual'
    },
    'contact-admin': {
        ar: 'يرجى مراجعة مدير النظام من اجل تعديل المنطقة الزمنية للمستخدم',
        en: 'Please contact the system administrator to update the user\'s time zone',
        es: 'Por favor, contacte al administrador del sistema para actualizar la zona horaria del usuario'
    },
    'hide-at-all': {
        ar: 'عدم العرض مرة اخرى',
        en: 'Don’t show again',
        es: 'No mostrar de nuevo'
    },
    "update-materials": {
        ar: 'تحديث أرصدة المواد',
        en: 'Update Materials',
        es: "Actualizar Materiales"
    },
    "update-materials-notifications": {
        ar: "تم تحديث أرصدة المواد بنجاح",
        en: "Materials updated successfully",
        es: "Los materiales se actualizaron correctamente"
    },
    "update-bond-notification": {
        "ar": "تم تحديث السند بنجاح",
        "en": "bond updated successfully",
        "es": "el comprobante se actualizó correctamente"
    }

}